import { Manager } from '../core';

export const get = async () => {
	try {
		const {data}: any = await Manager.request(
			'get',
			'/admin/availability/get.php',
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.availability.get', err)
	}
}

export const save = async (payload: any) => {
	try {
		const {data}: any = await Manager.request(
			'post',
			'/admin/availability/save.php',
			payload
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.availability.save', err)
	}
}
